import React, { useEffect, useRef, useState } from 'react';
import { Building2, ChevronDown } from 'lucide-react';
import { VersicherungLogo } from './VersicherungCard';

const API = process.env.REACT_APP_BACKEND_URL;

/** Feld „Gesellschaft“ mit Vorschlagsliste aller bereits an anderen Objekten eingetragenen Versicherungen. */
export const GesellschaftCombobox = ({ value, onChange, onPick, placeholder }) => {
  const [list, setList] = useState([]);
  const [open, setOpen] = useState(false);
  const wrap = useRef(null);
  useEffect(() => {
    fetch(`${API}/api/versicherung/gesellschaften`, { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } })
      .then((r) => (r.ok ? r.json() : { gesellschaften: [] })).then((d) => setList(d.gesellschaften || [])).catch(() => {});
  }, []);
  useEffect(() => {
    const close = (e) => { if (!wrap.current?.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', close);
    return () => document.removeEventListener('mousedown', close);
  }, []);
  const q = (value || '').trim().toLowerCase();
  const hits = list.filter((g) => !q || g.gesellschaft.toLowerCase().includes(q));
  const pick = (g) => { onPick(g); setOpen(false); };
  return (
    <div ref={wrap} className="relative">
      <label className="block text-[11px] font-medium text-gray-600 mb-0.5">Gesellschaft</label>
      <div className="relative">
        <input type="text" value={value} onChange={(e) => { onChange(e.target.value); setOpen(true); }} onFocus={() => setOpen(true)} placeholder={placeholder}
          data-testid="versicherung-gesellschaft" autoComplete="off"
          className="w-full px-2.5 py-1.5 pr-8 text-sm border border-gray-200 rounded-lg focus:ring-2 focus:ring-brand-navy/20 outline-none" />
        {list.length > 0 && (
          <button type="button" onClick={() => setOpen((o) => !o)} className="absolute right-1.5 top-1/2 -translate-y-1/2 p-1 text-gray-400 hover:text-brand-navy" title="Gespeicherte Gesellschaften" data-testid="versicherung-gesellschaft-toggle">
            <ChevronDown className={`w-4 h-4 transition-transform ${open ? 'rotate-180' : ''}`} />
          </button>
        )}
      </div>
      {open && hits.length > 0 && (
        <ul className="absolute z-30 left-0 right-0 mt-1 bg-white border border-gray-200 rounded-lg shadow-lg max-h-56 overflow-auto py-1" data-testid="versicherung-gesellschaft-liste">
          <li className="px-3 py-1 text-[10px] uppercase tracking-wider text-gray-400 flex items-center gap-1"><Building2 className="w-3 h-3" /> Bereits eingetragene Gesellschaften</li>
          {hits.map((g) => (
            <li key={g.gesellschaft}>
              <button type="button" onMouseDown={(e) => e.preventDefault()} onClick={() => pick(g)} data-testid={`versicherung-gesellschaft-option-${g.gesellschaft.replace(/\s+/g, '-').toLowerCase()}`}
                className="w-full flex items-center gap-2.5 px-3 py-1.5 text-left hover:bg-gray-50">
                <VersicherungLogo v={g} className="w-7 h-7 shrink-0" />
                <span className="min-w-0 flex-1">
                  <span className="block text-sm text-gray-800 truncate">{g.gesellschaft}</span>
                  <span className="block text-[10px] text-gray-500 truncate">{[g.email, g.telefon].filter(Boolean).join(' · ') || 'ohne Kontaktdaten'} · {g.objekte} Objekt{g.objekte === 1 ? '' : 'e'}</span>
                </span>
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
